module.exports = {"status":200,"data":[{"id":1,"yclmc":"封堵剂","dh":"PFT","ggxh":"50KG/桶","dw":"吨","sqsl":"10","cgsl":"10","dj":"100","xqdh":"20230515-02","bz":""},{"id":2,"yclmc":"封堵剂","dh":"LAT","ggxh":"25KG/袋","dw":"吨","sqsl":"15","cgsl":"10","dj":"100","xqdh":"20230515-02","bz":""}]}


//////////////////
// WEBPACK FOOTER
// ./src/mock/json/materialPurchasePlanMaterial.json
// module id = 20g7
// module chunks = 17